import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Dark hero band under the manual header (same look as home-2) — content cards overlap it via -mt */
@Component({
  selector: 'app-manual-hero',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section
      class="-mx-4 -mt-5 bg-(--header-background) rounded-b-[2.5rem] px-5 pt-3 pb-12 shadow-[0_12px_28px_rgba(58,58,58,0.28)] relative overflow-hidden text-left"
    >
      <div class="absolute -right-9 -top-5 w-[120px] h-[120px] rounded-full bg-[rgba(255,197,39,0.12)] pointer-events-none"></div>
      <div class="absolute right-10 bottom-3 w-14 h-14 rounded-full bg-[rgba(255,197,39,0.08)] pointer-events-none"></div>
      <div class="relative z-10 flex items-start gap-3">
        <div *ngIf="icon" class="w-11 h-11 rounded-2xl bg-(--main-color) flex items-center justify-center shrink-0">
          <img [src]="icon" alt="" class="w-6 h-6" />
        </div>
        <div class="min-w-0">
          <p *ngIf="eyebrow" class="text-[11px] font-medium text-white/60 m-0">{{ eyebrow }}</p>
          <h2 class="text-lg font-extrabold text-white leading-tight m-0 mt-0.5">{{ title }}</h2>
          <p *ngIf="subtitle" class="text-xs text-white/70 leading-relaxed m-0 mt-1.5">{{ subtitle }}</p>
          <ng-content></ng-content>
        </div>
      </div>
    </section>
  `,
})
export class ManualHeroComponent {
  @Input() eyebrow = '';
  @Input({ required: true }) title = '';
  @Input() subtitle = '';
  @Input() icon = '';
}
